import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_ResponsivePIXIApp } from "../SlotGameType1_ResponsivePIXIApp";
import { MarkersInfoColors } from "../WinLineInfoMarkers";
export class LuckyFire40Delux_ResponsivePIXIApp extends SlotGameType1_ResponsivePIXIApp {

    public override isDeluxGame: boolean = true;
    protected override helpFactory: IHelpFactory = new LuckyFire40DeluxHelpFactory();
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "LuckyFire40Delux");
        this.spinnableReelsParams.topBorderWidth = 0;
        this.spinnableReelsParams.bottomBorderWidth = 0;
    }
    //SEND COLOR 
    protected override color: RewardColor =
        {
            color: "white",
            coloroutherStroke: "black",
            colorinnerStroke: "red",
        }

    // protected override colorLineMarkers: MarkersInfoColors =
    //     {
    //         MarkerbackgroundColor: "linear-gradient(90deg, rgb(13, 38, 34),rgb(13, 38, 34), rgb(26,115,99),rgb(13, 38, 34),rgb(13, 38, 34)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
    //     };
    protected override colorLineMarkers: MarkersInfoColors =
    {
        MarkerbackgroundColor: "linear-gradient(to right, #f03000 0%, #ffd500 50%, #f03000 100%), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)"
    };
}

//Help Colorized
class LuckyFire40DeluxHelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new LuckyFire40DeluxHelp(params);
    }
}

class LuckyFire40DeluxHelp extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(13, 38, 34),rgb(13, 38, 34), rgb(26,115,99),rgb(13, 38, 34),rgb(13, 38, 34)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };
        return color;
    }
}
